<template>
  <div v-if="app && app.meta && app.meta.version">
    <h3>{{ app.meta.title }}</h3>
    <blockquote
      class="quote"
      v-if="app.meta.version">
      <span>
        {{ $t('components.appMetadata.version', 'Version {version}', { version: app.meta.version}) }}
      </span>
      <br>
      <span v-if="app.meta.buildDate">
        {{ $t('components.appMetadata.buildDate', 'Last update: ') }}{{ app.meta.buildDate | moment("DD/MM/YYYY") }} ({{ app.meta.buildDate | moment("from") }})
      </span>
    </blockquote>
  </div>
</template>

<script>

export default {
  props: {
    app: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .quote {
    border-left: 4px solid rgba(66,185,131,.3);
    color: #55789b;
    margin-left: 0;
    padding-left: 16px;
  }
</style>
